import strings from '../../Localization/Localization';

import {
  getTransatelRatePlans,
  getTransatelOptions
} from '../../API/TransatelMVNO'

let name = {
  fieldKey: "name",
  type: "text",
  label: strings.form.alphalinkMobileProduct.name.label,
  validators: []
}

let transatelRatePlan = {
  fieldKey: "transatel_rate_plan",
  type: "dropdown",
  label: strings.form.transatelMobileProduct.transatelRatePlan.label,
  validators: [],

  showEmpty: true,
  input: 'formValues',
  compute: (getValues, extraValues) => {
    if(extraValues.transatelRatePlans["request_status"] === 200) {
      return extraValues.transatelRatePlans.result.data.map((transatelRatePlan) => {
        return {
          value: transatelRatePlan["transatel_reference"],
          label: transatelRatePlan["name"]
        };
      });
    }

    return []
  }
}

let transatelDataThreshold = {
  fieldKey: "transatel_data_threshold",
  type: "dropdown",
  label: strings.form.transatelMobileProduct.transatelDataThreshold.label,
  validators: [],

  showEmpty: true,
  input: 'formValues',
  compute: (getValues, extraValues) => {
    let options = [];
    if(extraValues.transatelOptions["request_status"] === 200) {
      extraValues.transatelOptions.result.data.forEach((transatelOption) => {
        if(transatelOption["transatel_group"] === "data_threshold") {
          options.push({
            value: transatelOption["transatel_reference"],
            label: transatelOption["name"]
          });
        }
      });
    }

    return options;
  }
}

let transatelOptions = {
  fieldKey: "transatel_options_object",
  type: 'configurableField',
  label: "",
  validators: [],

  subField: (value, getValues, getExtraValues) => {
    let extraValues = getExtraValues();

    let fields = [];

    if(extraValues.transatelOptions["request_status"] === 200) {
      extraValues.transatelOptions.result.data.forEach((transatelOption, i) => {
        if(transatelOption["transatel_group"] === "data_threshold") {
          return;
        }
        let field = null;
        let valid = false;
        switch(transatelOption["option_type"]) {
          case "group":
            if(fields.some((field) => field.fieldKey === `transatel_option-${transatelOption["transatel_group"]}`)) {
              field = fields.find((field) => field.fieldKey === `transatel_option-${transatelOption["transatel_group"]}`);
            }
            else {
              valid = true;
              field = {
                fieldKey: `transatel_option-${transatelOption["transatel_group"]}`,
                type: "dropdown",
                label: strings.form.transatelMobileProduct.transatelOptions.custom[transatelOption["transatel_group"]],
                validators: [],

                showEmpty: true,
                options: []
              }
            }
            field.options.push({
              value: transatelOption["transatel_reference"],
              label: transatelOption["name"],
            });
            break;
          case "onoff":
            valid = true;
            field = {
              fieldKey: transatelOption["transatel_reference"],
              type: "switch",
              label: transatelOption["name"],
              validators: [],
              defaultValue: false
            }
            break;
          default:
            console.error("unknown option_type");
        }

        if(valid) {
          fields.push(field);
        }
      });
    }

    return {
      subForm: {
        formKey: "transatel_options",
        fields: fields
      }
    }
  },
  subFieldConf: {
    label: (value) => strings.form.transatelMobileProduct.transatelOptions.label,
    type: (value) => 'subform',
    disabled: () => false,
    validators: (value) => []
  },
}

/*
let transatelOptions_Display = {
  fieldKey: "transatel_options",
  type: 'array',
  label: strings.form.transatelMobileProduct.transatelOptions.label_Display,
  validators: [],

  defaultNumberOfField: 0,
  allowMoreField: true,

  allowMoreFieldAddLabel: strings.form.transatelMobileProduct.transatelOptions.allowMoreField.addLabel,
  allowMoreFieldRemoveLabel: strings.form.transatelMobileProduct.transatelOptions.allowMoreField.removeLabel,
  allowMoreFieldRemovingLabel: strings.form.transatelMobileProduct.transatelOptions.allowMoreField.removingLabel,

  subField: {
    type: "text",
    label: strings.form.transatelMobileProduct.transatelOptions.label,
    validators: []
  }
}
*/

export const form = {
  formKey: "transatelMobileProduct",
  fields: [
    name,
    transatelRatePlan,
    transatelDataThreshold,
    transatelOptions,
    // transatelOptions_Display
  ],
  extraValues: {
    transatelRatePlans: {
      type: "load",
      loader: {
        loader: getTransatelRatePlans,
        loaderRequire: () => true,
        loaderArguments: () => [],
        onLoaded: (values, getExtraValues, onChangeField, onChangeValues) => {
          let transatelRatePlans = getExtraValues().transatelRatePlans.result.data

          if(!!values["transatel_rate_plan"]) {
            transatelRatePlans.forEach((transatelRatePlan, i) => {
              if(values["transatel_rate_plan"].id === transatelRatePlan.id) {
                onChangeValues({
                  transatel_rate_plan: transatelRatePlan["transatel_reference"]
                })
              }
            });
          };
        }
      }
    },
    transatelOptions: {
      type: "load",
      loader: {
        loader: getTransatelOptions,
        loaderRequire: () => true,
        loaderArguments: () => [],
        onLoaded: (values, getExtraValues, onChangeField, onChangeValues) => {
          let transatelDataThreshold = null;
          let transatelOptionsObject = {};
          let transatelOptions = getExtraValues().transatelOptions.result.data;

          if(!!values["transatel_options"]) values["transatel_options"].forEach((option, i) => {
            transatelOptions.forEach((transatelOption, i) => {
              if(option.id === transatelOption.id) {
                if(transatelOption["transatel_group"] === "data_threshold") {
                  transatelDataThreshold = transatelOption["transatel_reference"];
                  return;
                }
                let fieldKey = null;
                switch(transatelOption["option_type"]) {
                  case "group":
                    fieldKey = `transatel_option-${transatelOption["transatel_group"]}`;
                    transatelOptionsObject[fieldKey] = transatelOption["transatel_reference"];
                    break;
                  case "onoff":
                    fieldKey = transatelOption["transatel_reference"];
                    transatelOptionsObject[fieldKey] = true;
                    break;
                  default:
                    console.error("unknown option_type");
                }
              }
            });
          });
          onChangeValues({
            transatel_data_threshold: transatelDataThreshold,
            transatel_options_object: transatelOptionsObject
          })
        }
      }
    }
  }
}
